import { render, staticRenderFns } from "./TaskParallelList.vue?vue&type=template&id=3a730637&scoped=true"
import script from "./TaskParallelList.vue?vue&type=script&lang=js"
export * from "./TaskParallelList.vue?vue&type=script&lang=js"
import style0 from "./TaskParallelList.vue?vue&type=style&index=0&id=3a730637&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a730637",
  null
  
)

export default component.exports